module.exports = __webpack_public_path__ + "img/logo.1e4b11c8.png";